import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { Container } from '@material-ui/core';
import { ItemIcon } from '../Home/Sections/OurOffer/OurOffer.styles';
import { DashboardStyleProps } from './Dashboard.interface';

export const StyledContainer = styled(Container)`
    padding-top: 100px;
`;

export const MarginWrapper = styled.div<DashboardStyleProps>`
    padding-top: ${props => props.verified ? '0' : '20px'};
    @media screen and (max-width: 690px) {
        padding-top: ${props => props.verified ? '0' : '50px'};
    }
`;

export const FlexWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    > div > svg {
        color: ${({ theme }) => theme.colors.primary};
        opacity: .54;
        margin-right: ${({ theme }) => theme.spacing * 2}px;
    }
`;

export const StyledItemIcon = styled(ItemIcon)`
    margin: 0;
`;

export const Wrapper = styled.div`
    width: 600px;
    @media screen and (max-width: 1280px) {
        width: 500px;
    }
    @media screen and (max-width: 960px) {
        width: 350px;
    }
    @media screen and (max-width: 600px) {
        width: 100%;
    }
`;

export const BuyMore = styled.button`
    margin: 0;
    color: ${({ theme }) => theme.colors.white};
    font-size: 12px;
    line-height: 44px;
    font-weight: bold;
    text-transform: uppercase;
    width: 100%;
    height: 44px;
    border-radius: 6px;
    padding: 0;
    background-color: ${({ theme }) => theme.colors.primary};
    border: none;
    outline: none;
    cursor: pointer;
`;

export const StyledLink = styled(Link)`
    text-align: right;
    font-size: 12px;
    text-decoration: none;
    text-transform: uppercase;
    font-weight: bold;
    margin-top: ${({ theme }) => theme.spacing * 6}px;
    color: ${({ theme }) => theme.colors.primary};
    display: block;
`;
